const state = {
  platformIconList: [
    {
      name: "今日头条",
      iconName: "tt"
    },
    {
      name: "微信",
      iconName: "wx"
    },
    {
      name: "知乎",
      iconName: "zh"
    },
    {
      name: "全网采集",
      iconName: "qwcj"
    }
  ]
};
const getters = {
  // ...
};
const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
